import { useQuery } from "@tanstack/react-query";
import { listParcours, type ParcoursSearchParams } from "../api/parcoursApi";
import { queryKeys } from "../lib/queryKeys";

export function useParcoursList(params: ParcoursSearchParams) {
  return useQuery({
    queryKey: queryKeys.parcours.list(params),
    queryFn: () => listParcours(params),
  });
}
